const STAR_POSITIONS: [number, number, number][][] = [
    [
        [43.22, 53.69, 0.6],
        [83.2, 96.28, 1.1],
        [93.62, 72.46, 0.5],
        [40.29, 40.14, 0.6],
        [1.55, 13.48, 0.8],
        [11.03, 86.14, 0.3],
        [97.32, 94.05, 0.7],
        [21.32, 47.49, 0.6],
        [71.07, 97.53, 0.6],
        [87.7, 98.59, 0.3],
        [5.18, 53.71, 1.2],
        [22.24, 65.41, 1],
        [69.98, 45.62, 0.7],
        [12.2, 6.82, 0.7],
        [58.35, 1.36, 0.6],
        [80.77, 22.19, 0.3],
        [42.38, 44.01, 0.5],
        [74.62, 25.62, 0.3],
        [26.63, 75.06, 1.1],
        [28.96, 22.33, 0.6],
        [89.2, 61.77, 0.9],
        [54.88, 87.24, 0.6],
        [60.71, 40.57, 0.7],
        [95.83, 3.55, 0.6],
        [98.49, 22.03, 0.4],
        [84.66, 29.19, 0.3],
        [50.54, 41.33, 0.3],
        [69.91, 65.61, 1],
        [11.19, 49.08, 0.9],
        [33.72, 37.99, 0.8],
        [52.6, 45.85, 0.6],
        [51.89, 25.86, 0.9],
        [39.01, 1.77, 1],
        [1.82, 13.18, 1.1],
        [4.76, 35.52, 0.4],
        [59.98, 69.34, 0.4],
        [41.12, 49.91, 0.4],
        [70.83, 35.73, 0.9],
        [48.85, 95.26, 0.4],
        [56.63, 67.95, 0.9],
        [72.64, 79.8, 1],
        [1.19, 32.04, 1.1],
        [3.26, 21.49, 0.8],
        [73.47, 49.61, 0.5],
        [95.31, 30.64, 0.5],
        [7.72, 33.83, 1.1],
        [77.97, 31.71, 0.4],
        [58.69, 89.48, 1.2],
        [81.71, 8.93, 0.5],
        [21.65, 22.5, 0.8],
        [46.27, 79.77, 1],
        [64.08, 64.14, 0.5],
        [16.23, 79.97, 0.9],
        [79.26, 69.63, 0.6],
        [50.07, 36, 1.1],
        [30.62, 32.65, 1.1],
        [63.38, 61.5, 0.9],
        [12.46, 29.07, 0.4],
        [14.03, 51.57, 0.9],
        [82.62, 65.36, 0.3],
        [74.94, 23.83, 1.1],
        [20.75, 62.45, 0.8],
        [90.94, 21.33, 0.8],
        [46.92, 23.67, 0.5],
        [82.99, 12.67, 0.5],
        [13.9, 13.53, 0.8],
        [48.44, 9.56, 0.9],
        [57.18, 21.67, 0.9],
        [46.91, 29.48, 0.7],
        [18.95, 52.73, 1],
        [66.97, 34.85, 1],
        [17.79, 76.97, 1],
        [58.25, 87.99, 0.5],
        [45.31, 82.05, 0.8],
        [56.33, 51.13, 1],
        [96.54, 7.55, 0.7],
        [78.93, 55.55, 0.8],
        [77.7, 55.28, 0.8],
        [67.38, 85.1, 0.4],
        [98.3, 32.19, 0.7],
        [4.62, 80.87, 0.3],
        [78.06, 77.29, 0.7],
        [21.08, 71.84, 0.8],
        [7.96, 35.71, 0.6],
        [24.64, 23.12, 0.3],
        [66.36, 86.3, 0.3],
        [40.48, 64.62, 1.1],
        [72.4, 1.25, 0.7],
        [56.91, 36.51, 0.8],
        [25.43, 36.72, 0.3],
        [69.95, 23.44, 1],
        [93.42, 72.16, 1],
        [80.05, 45.55, 1.2],
        [47.34, 60.11, 0.3],
        [76.51, 87.2, 0.7],
        [80.63, 57.66, 0.8],
        [79.89, 8.71, 0.3],
        [85.51, 52.85, 1.2],
        [54.47, 94.93, 0.6],
        [13.66, 43.59, 0.5],
    ],
    [
        [15.05, 13.42, 1.1],
        [64.67, 55.5, 0.5],
        [4.9, 98.82, 0.9],
        [81.89, 29.41, 0.4],
        [60.76, 80.6, 0.9],
        [69.82, 77.89, 0.8],
        [0.19, 85.34, 1.1],
        [34.83, 79.55, 0.9],
        [52.49, 68.8, 0.9],
        [73.01, 33.34, 0.6],
        [64.75, 65.22, 0.6],
        [10.73, 52.44, 0.5],
        [50.2, 42.96, 0.3],
        [26.82, 63.06, 1],
        [41.8, 3.25, 1.2],
        [68.26, 76.52, 0.6],
        [37.06, 58.76, 0.6],
        [39.53, 30.1, 1.2],
        [62.71, 5.41, 1.1],
        [33.48, 14.38, 0.7],
        [35.52, 88.71, 0.3],
        [77.07, 64.78, 0.6],
        [21.5, 90.69, 1],
        [6.1, 25.62, 0.6],
        [44.29, 84.15, 0.5],
        [42.87, 30.42, 0.5],
        [79.53, 13.93, 0.7],
        [79.93, 59.21, 1],
        [39.17, 26.45, 0.8],
        [76.86, 4.93, 0.8],
        [84.91, 37.02, 0.6],
        [50.06, 91.24, 0.4],
        [97.69, 59.92, 0.9],
        [4.59, 91.7, 0.7],
        [95.4, 92.12, 0.4],
        [77.8, 34.67, 0.3],
        [74.58, 82.28, 0.8],
        [62.74, 57.42, 0.7],
        [21.38, 3.56, 0.8],
        [50, 53.93, 0.4],
        [35.47, 56.29, 1],
        [24.66, 14.76, 0.9],
        [0.49, 71.92, 0.5],
        [53.62, 42.7, 0.6],
        [44.2, 36.66, 0.7],
        [15.86, 55.67, 0.7],
        [75.02, 45.81, 1.2],
        [50.62, 4.57, 1],
        [53.17, 85.49, 0.3],
        [4.11, 85.62, 0.4],
        [35.09, 83.38, 1.2],
        [51.46, 18.34, 0.9],
        [27.53, 50.81, 0.3],
        [38.77, 13.39, 0.4],
        [87.97, 58.68, 0.7],
        [64.23, 19.63, 0.5],
        [77.27, 71.03, 1.1],
        [87.25, 16.14, 0.8],
        [11.33, 53.69, 1.2],
        [5.71, 81.82, 0.3],
        [46.92, 4.53, 0.8],
        [65.97, 8.21, 0.3],
        [47.02, 90.43, 1.1],
        [29.55, 94.73, 0.7],
        [36, 40.63, 1.2],
        [6.52, 2, 0.7],
        [71.77, 72.71, 1.1],
        [11.6, 48.69, 0.5],
        [33.33, 90.3, 1.1],
        [2.89, 96.91, 1],
        [11.74, 54.59, 0.3],
        [78.56, 27.7, 0.9],
        [58.94, 5.46, 0.9],
        [52.9, 43.95, 0.5],
        [49.38, 66.63, 1],
        [77.35, 73.45, 1],
        [42.66, 70.73, 0.8],
        [51.82, 15.5, 0.6],
        [97.92, 35.03, 1],
        [15.97, 90.3, 0.9],
        [32.65, 88.89, 1],
        [52.55, 24.72, 0.6],
        [1, 2.9, 0.5],
        [70.19, 70.11, 1],
        [76.61, 48.13, 0.9],
        [82.75, 5.77, 0.5],
        [57.51, 80.78, 0.5],
        [23.27, 87.38, 0.3],
        [78.77, 34.03, 0.7],
        [38.07, 45.09, 0.8],
        [67.65, 27.15, 0.6],
        [21.35, 52.39, 0.9],
        [98.91, 7.3, 1.2],
        [50.98, 76.39, 0.4],
        [49.8, 6.17, 1],
        [94.85, 86.9, 1.1],
        [33.67, 81.92, 0.4],
        [1.04, 39.26, 0.4],
        [27.12, 99.21, 1.1],
        [84.24, 41.17, 0.3],
    ],
    [
        [61.92, 27.83, 1.2],
        [95.73, 92.8, 0.9],
        [13.29, 20.64, 1],
        [69.96, 60.67, 0.6],
        [80.44, 98.09, 1.1],
        [54.98, 86.82, 1],
        [11.55, 95.31, 0.6],
        [75.69, 99.83, 0.5],
        [96.51, 2.25, 0.5],
        [4.69, 91.03, 0.3],
        [66.06, 67.27, 0.5],
        [94.99, 70.37, 0.4],
        [27.17, 59.74, 1],
        [79.05, 78.93, 0.4],
        [82.8, 13.64, 0.6],
        [17.93, 42.12, 1.2],
        [27.67, 40.18, 0.6],
        [32.06, 37.96, 1.1],
        [10.73, 72.11, 0.7],
        [41.38, 29.27, 1.2],
        [67.5, 8.21, 1.1],
        [77.51, 48.42, 0.5],
        [14.31, 59.62, 0.9],
        [28.67, 66.04, 0.3],
        [32.39, 7.91, 1.2],
        [64.99, 82.84, 1.2],
        [15.55, 86.4, 1.2],
        [5.02, 0.16, 0.5],
        [76.74, 24.68, 0.9],
        [99.75, 65.99, 0.5],
        [97.42, 61.82, 0.9],
        [48.6, 13.43, 0.4],
        [14.21, 11.12, 0.8],
        [26.07, 43.74, 0.4],
        [92.62, 34.28, 1],
        [21.77, 66.46, 0.8],
        [61.47, 39.79, 0.9],
        [8.97, 98.36, 0.5],
        [84.35, 21.72, 1.2],
        [33.75, 68.03, 1],
        [59, 71.53, 1.1],
        [20.03, 54.17, 1.2],
        [48.68, 51.26, 0.4],
        [34.11, 89.22, 1.2],
        [80.64, 86.32, 1.2],
        [43.64, 8.2, 1.1],
        [6.46, 22.29, 0.4],
        [19.28, 3.35, 1.2],
        [87.28, 18.46, 0.8],
        [41.37, 82.31, 0.5],
        [29.29, 27.14, 1.2],
        [43.66, 29.11, 0.7],
        [60.62, 24.43, 0.5],
        [56.01, 97.05, 0.3],
        [66.66, 10.58, 0.4],
        [77.78, 16.55, 0.9],
        [80.98, 2.2, 1.2],
        [86.71, 11.27, 1.1],
        [81.68, 64.74, 1.1],
        [19.33, 93.91, 0.5],
        [22.47, 66.62, 0.4],
        [7.36, 86.58, 0.6],
        [78.19, 40.85, 0.9],
        [61.84, 49.77, 0.5],
        [34.52, 87.93, 1.1],
        [80.67, 55.25, 1.1],
        [5.11, 53.12, 1.1],
        [35.45, 84.73, 1.1],
        [79.74, 41.21, 0.4],
        [68.3, 7.51, 0.8],
        [26.23, 24.34, 0.9],
        [29.6, 10.72, 0.6],
        [28.49, 45.64, 0.7],
        [77.48, 3.26, 1.1],
        [53.99, 96.84, 0.6],
        [54.35, 78.22, 1],
        [48.34, 89.78, 0.9],
        [70.37, 27.13, 0.3],
        [71.03, 69.19, 0.8],
        [60.3, 12.16, 0.4],
        [77.17, 85.27, 1.1],
        [93.3, 48.15, 0.6],
        [18.17, 23.42, 1],
        [72.15, 46.69, 1.2],
        [24.43, 72.21, 0.7],
        [89.23, 33.85, 1],
        [3.3, 59.57, 0.4],
        [90.29, 48.4, 0.3],
        [23.62, 41.4, 0.4],
        [91.99, 57.8, 0.9],
        [28.7, 49.62, 1.2],
        [48.72, 14.29, 0.8],
        [41.13, 52.4, 1.2],
        [17.43, 64.06, 0.5],
        [9.22, 49.62, 0.7],
        [55.62, 59.84, 0.7],
        [99.25, 61.05, 0.8],
        [32.99, 93.96, 0.7],
        [45.93, 40.76, 0.9],
        [36.07, 51.81, 1.1],
    ],
]

export default STAR_POSITIONS
